/* eslint-disable max-len */
import { call, put, takeLatest } from 'redux-saga/effects';
import safeSaga from '../safeSaga';
import { UPDATE_PREV_LOGO_TO_NEW_LINEITEMID, UPDATE_URL_FOR_UPLOAD_IMAGES } from '../../actions/actionTypes';
import { addPrevLogoToNewLineItemApi } from '../../api/eleanorApi';
import { updateAddToBundleDisabled } from '../../actions/configAction';
import { getUploadImagesParams } from '../../utils/uploadImagesUtil';

function* updateAddPrevLogoToNewLineItemSaga(action) {
  try {
    const uploadImageParams = getUploadImagesParams(action.payload.uploadImageParam);
    const params = {
        SourceUploadType: uploadImageParams.uploadType,
        SourceLineItemId: uploadImageParams.lineItemId,
        DestinationUploadType: uploadImageParams.uploadType,
        DestinationLineItemId: action.payload.guid,
    };
    const response = yield call(addPrevLogoToNewLineItemApi, params);
    if (response) {
        const payload = {
            guid: action.payload.guid,
            uploadImageParams,
            uploadedImages: response.fileResults,
        };
        yield put({ type: UPDATE_URL_FOR_UPLOAD_IMAGES, payload });
        yield put(updateAddToBundleDisabled({ isAddtoBundleDisabled: false }));
    }
  } catch (error) {
    // eslint-disable-next-line no-console
  }
}
export default function* addPrevLogoToNewLineItemSaga() {
  yield takeLatest(UPDATE_PREV_LOGO_TO_NEW_LINEITEMID, safeSaga(updateAddPrevLogoToNewLineItemSaga));
}
